import {
  GETTER_IS_LOADING,
  GETTER_VALIDATION_ERROR_MESSAGE,
} from './types';

export default {
  [GETTER_IS_LOADING]: ({ isLoading }) => isLoading,
  [GETTER_VALIDATION_ERROR_MESSAGE]: ({ validationErrorMessage }) => validationErrorMessage,
};
